import React from 'react';
import { clsx } from 'clsx';

import type { EmbeddedComponent } from '../../../../../core/data-sources/content-components/types.js';

import { DangerouslySetHtmlContent } from './DangerousHtml.js';

const Integration: React.FC<EmbeddedComponent> = ({
  embed,
  presentationProperties,
}) => {
  const layout = presentationProperties?.addLayout;

  return (
    <DangerouslySetHtmlContent
      className={clsx('integration-enrichment', layout)}
      html={embed?.html || ''}
    />
  );
};

export default Integration;
